export enum Tabs {
  General = 'general',
  MobileSettings = 'mobile_settings',
  ActivitySettings = 'activity_settings',
  PreferenceSettings = 'preference_settings',
  VehicleSettings = 'vehicle_settings',
  LocationSettings = 'location_settings',
  RouteSettings = 'route_settings',
  LabelSettings = 'label_settings',
  IssuesSettings = 'issues_settings',
  InvoiceSettings = 'invoice_settings',
  AlgorithmSettings = 'algorithm_settings',
  AbsencesSettings = 'absences_settings',
  ShiftSettings = 'shift_settings',
  ExportSettings = 'export_settings',
  ActivityPropertiesSettings = 'activity_properties_settings',
}
